'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/share/ShareIcon.tsx
import { jsx } from "react/jsx-runtime";
var ShareIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 3.5C15.6193 3.5 14.5 4.61929 14.5 6C14.5 7.38071 15.6193 8.5 17 8.5C18.3807 8.5 19.5 7.38071 19.5 6C19.5 4.61929 18.3807 3.5 17 3.5ZM13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6C21 8.20914 19.2091 10 17 10C15.7385 10 14.6134 9.41603 13.8803 8.50367L9.82364 10.8217C9.93829 11.1942 10 11.5899 10 12C10 12.4101 9.93829 12.8058 9.82364 13.1783L13.8803 15.4963C14.6134 14.584 15.7385 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.5899 13.0617 17.1942 13.1764 16.8217L9.11974 14.5037C8.38661 15.416 7.2615 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C7.2615 8 8.38661 8.58397 9.11974 9.49633L13.1764 7.17827C13.0617 6.80578 13 6.4101 13 6ZM6 9.5C4.61929 9.5 3.5 10.6193 3.5 12C3.5 13.3807 4.61929 14.5 6 14.5C7.38071 14.5 8.5 13.3807 8.5 12C8.5 10.6193 7.38071 9.5 6 9.5ZM17 15.5C15.6193 15.5 14.5 16.6193 14.5 18C14.5 19.3807 15.6193 20.5 17 20.5C18.3807 20.5 19.5 19.3807 19.5 18C19.5 16.6193 18.3807 15.5 17 15.5Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  ShareIcon
};
//# sourceMappingURL=chunk-SFWF5DMQ.mjs.map